import clsx from 'clsx';
import React from 'react';
import { useMedia } from 'react-use';
import { BREAKPOINTS } from '../../../common/constants';
import AgencyContactTable from './AgencyContactTable';

const AgenciesContact = ({ agencyId }) => {
  const isDesktopViewport = useMedia(`(min-width: ${BREAKPOINTS.desktop}px)`);
  return (
    <div className="agency-contact-card setup-module">
      <div
        className={clsx(
          'header',
          'd-flex',
          'align-center',
          'justify-between',
          isDesktopViewport && 'mb-10',
        )}
      >
        {isDesktopViewport && (
          <h1 className="mr-10">
            Team Users
            <div id="team-user-sub-header" />
          </h1>
        )}
        <div
          className={`agency-header-buttons d-flex ${
            !isDesktopViewport ? 'width-percent-100' : ''
          }`}
        >
          <div
            id="add-btn-contact"
            className="d-flex align-center justify-between width-percent-100"
          />
        </div>
      </div>
      <AgencyContactTable agencyId={agencyId} />
    </div>
  );
};

export default AgenciesContact;
